import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { SEOHead } from '../components/site/SEOHead';

export default function NotFound() {
  // Keep search engines from indexing 404s (incl. sections switched off in the admin).
  useEffect(() => {
    const el = document.createElement('meta');
    el.setAttribute('name', 'robots');
    el.setAttribute('content', 'noindex');
    document.head.appendChild(el);
    return () => el.remove();
  }, []);

  return (
    <div
      className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 py-20"
      data-testid="not-found-page"
    >
      <SEOHead title="Sayfa Bulunamadı (404)" description="Aradığınız sayfa bulunamadı." />
      <div className="font-heading text-[6rem] leading-none font-bold text-[hsl(var(--gold))] select-none">404</div>
      <h1 className="font-heading text-2xl md:text-3xl font-semibold mt-2 mb-3">Sayfa Bulunamadı</h1>
      <p className="text-muted-foreground max-w-md mb-8">
        Aradığınız sayfa taşınmış, adı değişmiş ya da hiç var olmamış olabilir. Aşağıdaki bağlantılardan devam edebilirsiniz.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors"
          data-testid="not-found-home-link"
        >
          <Home className="w-4 h-4" /> Ana Sayfaya Dön
        </Link>
        <button
          type="button"
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-border text-sm font-medium hover:bg-secondary transition-colors"
          data-testid="not-found-back-button"
        >
          <ArrowLeft className="w-4 h-4" /> Geri Git
        </button>
      </div>
    </div>
  );
}
